<div class="contact">
  <div class="contact-head">
    <span class="contact-head-title">{{
      'habaContactForm.formProductAdvisor.contactUs' | cxTranslate
    }}</span>
    <span class="contact-head-description">{{
      'habaContactForm.formProductAdvisor.option.description' | cxTranslate
    }}</span>
  </div>
  <div class="contact-option-container">
    <a class="contact-option" [routerLink]="contactFormUrl" (click)="trackClick('product_advisor_contact_form', contactFormUrl)">
      <div class="contact-icon">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.9978 14.9987C20.9978 15.5291 20.7871 16.0377 20.4121 16.4128C20.037 16.7878 19.5284 16.9985 18.998 16.9985H6.99932L2.99976 20.998V4.99978C2.99976 4.46941 3.21045 3.96075 3.58548 3.58572C3.96051 3.21069 4.46916 3 4.99954 3H18.998C19.5284 3 20.037 3.21069 20.4121 3.58572C20.7871 3.96075 20.9978 4.46941 20.9978 4.99978V14.9987Z"
            stroke="#3A92A0"
            stroke-width="1.99978"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <div class="contact-option-text">
        <span class="contact-option-text-title">{{
          'habaContactForm.form.legend' | cxTranslate
        }}</span>
        <span class="contact-option-text-description">{{
          'habaContactForm.formProductAdvisor.option.message' | cxTranslate
        }}</span>
      </div>
    </a>
    <a class="contact-option" [href]="emailUrl" (click)="trackClick('product_advisor_email', emailUrl)">
      <div class="contact-icon">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.9978 14.9987C20.9978 15.5291 20.7871 16.0377 20.4121 16.4128C20.037 16.7878 19.5284 16.9985 18.998 16.9985H6.99932L2.99976 20.998V4.99978C2.99976 4.46941 3.21045 3.96075 3.58548 3.58572C3.96051 3.21069 4.46916 3 4.99954 3H18.998C19.5284 3 20.037 3.21069 20.4121 3.58572C20.7871 3.96075 20.9978 4.46941 20.9978 4.99978V14.9987Z"
            stroke="#3A92A0"
            stroke-width="1.99978"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <div class="contact-option-text">
        <span class="contact-option-text-title">{{
          'habaContactForm.formProductAdvisor.option.mail' | cxTranslate
        }}</span>
        <span class="contact-option-text-description">beratung&#64;wehrfritz.de</span>
      </div>
    </a>
    <a class="contact-option" [href]="callUrl" (click)="trackClick('product_advisor_call', callUrl)">
      <div class="contact-icon">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.9978 14.9987C20.9978 15.5291 20.7871 16.0377 20.4121 16.4128C20.037 16.7878 19.5284 16.9985 18.998 16.9985H6.99932L2.99976 20.998V4.99978C2.99976 4.46941 3.21045 3.96075 3.58548 3.58572C3.96051 3.21069 4.46916 3 4.99954 3H18.998C19.5284 3 20.037 3.21069 20.4121 3.58572C20.7871 3.96075 20.9978 4.46941 20.9978 4.99978V14.9987Z"
            stroke="#3A92A0"
            stroke-width="1.99978"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <div class="contact-option-text">
        <span class="contact-option-text-title">{{
          'habaContactForm.formProductAdvisor.option.call' | cxTranslate
        }}</span>
        <span class="contact-option-text-description">+49 (0) 96 22 / 18 - 0</span>
      </div>
    </a>
  </div>
  <form class="contact-form" (ngSubmit)="submitForm()" [formGroup]="contactForm" *ngIf="!closed">
    <div class="contact-form-text">
      <span class="contact-form-text-title">{{
        'habaContactForm.formProductAdvisor.option.call' | cxTranslate
      }}</span>
      <span class="contact-form-text-description">{{
        'habaContactForm.formProductAdvisor.description' | cxTranslate
      }}</span>
    </div>
    <div class="contact-form-row">
      <div class="contact-form-input-container">
        <label for="firstName"> {{ 'habaContactForm.form.firstName.label' | cxTranslate }}</label>
        <input type="text" name="firstName" id="firstName" formControlName="firstName" />
        <app-form-error
          *ngIf="
            contactForm.get('firstName')?.touched &&
            contactForm.get('firstName')?.errors?.['required']
          "
        >
          {{ 'habaContactForm.form.firstName.error' | cxTranslate }}
        </app-form-error>
        <app-form-error
          *ngIf="
            contactForm.get('firstName')?.touched &&
            contactForm.get('firstName')?.errors?.['invalidName']
          "
        >
          {{ 'habaContactForm.form.messages.notValidError' | cxTranslate }}
        </app-form-error>
      </div>
      <div class="contact-form-input-container">
        <label for="lastName"> {{ 'habaContactForm.form.lastName.label' | cxTranslate }}</label>
        <input type="text" name="lastName" id="lastName" formControlName="lastName" />
        <app-form-error
          *ngIf="
            contactForm.get('lastName')?.touched &&
            contactForm.get('lastName')?.errors?.['required']
          "
        >
          {{ 'habaContactForm.form.lastName.error' | cxTranslate }}
        </app-form-error>
        <app-form-error
          *ngIf="
            contactForm.get('lastName')?.touched &&
            contactForm.get('lastName')?.errors?.['invalidName']
          "
        >
          {{ 'habaContactForm.form.messages.notValidError' | cxTranslate }}
        </app-form-error>
      </div>
    </div>

    <div class="contact-form-row">
      <div class="contact-form-input-container">
        <label for="email"> {{ 'habaContactForm.form.email.label' | cxTranslate }} *</label>
        <input type="email" name="email" id="email" formControlName="email" />
        <app-form-error
          *ngIf="
            contactForm.get('email')?.touched && contactForm.get('email')?.errors?.['required']
          "
        >
          {{ 'habaContactForm.form.email.error' | cxTranslate }}
        </app-form-error>
        <app-form-error
          *ngIf="
            contactForm.get('email')?.touched && contactForm.get('email')?.errors?.['invalidMail']
          "
        >
          {{ 'habaContactForm.form.messages.notValidError' | cxTranslate }}
        </app-form-error>
      </div>
    </div>

    <div class="contact-form-row">
      <div class="contact-form-input-container">
        <label for="phone"> {{ 'habaContactForm.form.phone.label' | cxTranslate }} *</label>
        <input type="tel" name="phone" id="phone" formControlName="phone" />
        <app-form-error
          *ngIf="
            contactForm.get('phone')?.touched && contactForm.get('phone')?.errors?.['required']
          "
        >
          {{ 'habaContactForm.form.phone.error' | cxTranslate }}
        </app-form-error>
        <app-form-error
          *ngIf="
            contactForm.get('phone')?.touched &&
            contactForm.get('phone')?.errors?.['invalidPhone']
          "
        >
          {{ 'habaContactForm.form.phone.formatError' | cxTranslate }}
        </app-form-error>
      </div>
    </div>

    <div class="contact-form-row split-long-fields">
      <div class="contact-form-input-container">
        <label for="zipCode"> {{ 'habaContactForm.form.postcode.error' | cxTranslate }} *</label>
        <input type="text" name="zipCode" id="zipCode" formControlName="zipCode" />
        <app-form-error
          *ngIf="
            contactForm.get('zipCode')?.touched && contactForm.get('zipCode')?.errors?.['required']
          "
        >
          {{ 'habaContactForm.form.postcode.error' | cxTranslate }}
        </app-form-error>
      </div>
      <div class="contact-form-input-container">
        <label for="customerNumber">{{
          'habaContactForm.form.customerNumber.label' | cxTranslate
        }}</label>
        <input
          type="text"
          name="customerNumber"
          id="customerNumber"
          formControlName="customerNumber"
        />
      </div>
    </div>
    <div class="contact-form-row">
      <span
        class="contact-form-disclaimer"
        [innerHTML]="'habaContactForm.form.isAgreed.label' | cxTranslate"
      ></span>
    </div>
    <div class="contact-form-row">
      <button class="contact-form-btn-submit" type="submit">
        {{ 'habaContactForm.form.submitRequest' | cxTranslate }}
      </button>
    </div>
  </form>
</div>
